import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Keeping track of menu expansion and loader visibility
import { useSelector, useDispatch } from "react-redux";
import {
  selectMenuOpen,
  setMenuOpen,
  selectLoaderProcesses,
} from "../../redux/features/applicationState/applicationStateSlice";

import CardLoader from "../CardLoader/CardLoader";

// Fade out BodyCard Content when sidebar is open on mobile.
const OpenSidebarOverlay = ({ menuOpenStatus }) => {
  const dispatch = useDispatch();

  // Handle closing sidebar when clicked outside of sidebar.
  const closeMenu = () => {
    dispatch(setMenuOpen(false));
  };

  return (
    <div
      className={`fixed z-[996] top-0 right-0 bottom-0 left-0 md:hidden
                  transition-all duration-200
                bg-black
                  ${
                    menuOpenStatus
                      ? "bg-opacity-[20%]"
                      : "pointer-events-none bg-opacity-0"
                  }
                `}
      onClick={closeMenu}
    />
  );
};

function BodyCard(props) {
  const menuOpenStatus = useSelector(selectMenuOpen);
  const loaderProcesses = useSelector(selectLoaderProcesses);

  // Scroll to top of div on route change.
  const scrollableDivRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (scrollableDivRef.current) {
      scrollableDivRef.current.scrollTop = 0;
    }
  }, [location]);

  return (
    <div
      className={`min-h-screen h-full w-full Xp-2 Xbg-red-500
                  transition-all duration-200
                  pt-12 md:pt-0
                  ${
                    menuOpenStatus
                      ? "md:pl-[6.5rem] ip11l:pl-[25.5rem]"
                      : "md:pl-[6.5rem]"
                  }
                 `}
    >
      <OpenSidebarOverlay menuOpenStatus={menuOpenStatus} />

      {loaderProcesses > 0 && <CardLoader menuOpenStatus={menuOpenStatus} />}

      <div
        ref={scrollableDivRef}
        className="min-h-[calc(100vh-3rem)] md:min-h-screen h-full w-full p-4 md:p-5
                   flex flex-col
                   md:rounded-l-3xl 
                   shadow-lg bg-white
                  "
      >
        {props.children}
      </div>
    </div>
  );
}

export default BodyCard;
